import { PLAN_CATALOG } from "./planLimits";

let cachedCatalog = null;
let pendingRequest = null;

function normalizeCatalog(plans = []) {
  if (!Array.isArray(plans) || !plans.length) return PLAN_CATALOG;
  const fallbackByKey = Object.fromEntries(PLAN_CATALOG.map((p) => [p.key, p]));

  return plans.map((plan) => {
    const key = String(plan.key || plan.backendKey || "basic").toLowerCase();
    const fallback = fallbackByKey[key] || fallbackByKey.basic;
    return { ...fallback, ...plan, key };
  });
}

export async function fetchPlanCatalog() {
  if (cachedCatalog) return cachedCatalog;
  if (pendingRequest) return pendingRequest;

  pendingRequest = fetch("/api/planCatalogPublic")
    .then(async (res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json().catch(() => ({}));
      cachedCatalog = normalizeCatalog(data?.plans);
      return cachedCatalog;
    })
    .catch(() => {
      cachedCatalog = PLAN_CATALOG;
      return cachedCatalog;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
}

export function getPlanFromCatalog(planKey, catalog = PLAN_CATALOG) {
  const normalized = String(planKey || "basic").toLowerCase();
  return catalog.find((p) => p.key === normalized || p.backendKey === normalized) || catalog[0];
}
